import CustomModal from "shared/components/modal/CustomModal";

interface ModalTermosDeUsoGroupPayProps {
  showModal: boolean;
  onCloseModal: () => void;
}

const ModalTermosDeUsoGroupPay: React.FC<ModalTermosDeUsoGroupPayProps> = (props) => {
  const renderTitulo = () => {
    return <h3 className="text-center align-items-center">Termo de uso - Group Pay</h3>;
  };

  const renderConteudo = () => {
    return (
      <div className="mt-3">
        <div>
          <p>
            Os presentes Termos de Uso se aplicam à ferramenta GROUP PAY (“SOFTWARE”), oferecida pela GROUP SOFTWARE
            LTDA. (“GROUP SOFTWARE”), pessoa jurídica de direito privado, inscrita no CNPJ/MF sob o n°
            01.413.092/0001-02, estabelecida à Rua Santa Catarina, nº 1.631, 5º Andar, Bairro Lourdes, Belo Horizonte,
            Minas Gerais, CEP: 30.170-081.
          </p>
          <p>
            Os Termos de Uso descrevem como o USUÁRIO pode acessar e usar o SOFTWARE. Ao acessar e usar a ferramenta, o
            USUÁRIO concorda com estes Termos. Caso contrário, deverá cessar imediatamente o acesso e uso do GROUP PAY.
          </p>
          <p>
            A GROUP SOFTWARE se reserva no direito de promover alterações nos presentes Termos e Condições Gerais de Uso
            a qualquer tempo para fins de atualização e melhoria na prestação dos serviços. O USUÁRIO será informado
            sobre as modificações efetuadas por meio do próprio ambiente do SOFTWARE.
          </p>
          <p>
            Todas as alterações entrarão em vigor imediatamente após serem postadas no GROUP PAY. A continuidade da
            utilização dos serviços após as alterações nos Termos e Condições Gerais de Uso significa que o USUÁRIO
            aceita estes termos e quaisquer alterações nos mesmos.
          </p>
          <p>
            O USUÁRIO está ciente que tais atualizações podem não ser compatíveis com softwares ou serviços fornecidos
            por terceiros não autorizados pela GROUP SOFTWARE.
          </p>
          <h4>I. DA LICENÇA DE USO DO GROUP PAY</h4>
          <p>
            I.1. Sujeito aos termos e condições aqui estabelecidos, estes Termos e Condições Gerais de Uso concedem ao
            USUÁRIO uma licença revogável, onerosa, não passível de sublicença, não exclusiva e intransferível para uso
            do GROUP PAY. Quaisquer direitos não expressamente outorgados por estes Termos e Condições Gerais de Uso são
            reservados à GROUP SOFTWARE.
          </p>
          <p>I.2. Para acessar o GROUP PAY, o USUÁRIO deverá inserir o seu nome de usuário e senha.</p>
          <h4>II. DAS OBRIGAÇÕES E RESPONSABILIDADES DO USUÁRIO</h4>
          <p>
            II.1. O USUÁRIO reconhece e aceita que o uso do GROUP PAY será feito por sua exclusiva responsabilidade,
            comprometendo-se a utilizar o GROUP PAY e todas as suas ferramentas de acordo com a legislação vigente, os
            bons costumes e os Termos de Uso.
          </p>
          <p>II.2. Como condição para utilizar o GROUP PAY, o USUÁRIO deverá, necessariamente:</p>
          <p>
            a) se, pessoa natural, ser maior de 18 anos, plenamente capaz e validamente inscrita no Cadastro de Pessoas
            Físicas do Ministério da Fazenda (CPF/MF);
          </p>
          <p>b) se, pessoa jurídica, ser validamente inscrita no Cadastro Nacional de Pessoas Jurídicas (CNPJ/MF);</p>
          <p>c) fornecer seus dados e informações verdadeiras, completas e atualizadas;</p>
          <p>
            d) não utilizar o GROUP PAY para fins ilícitos e/ou ilegais, que atentem contra direitos de terceiros e/ou
            que infrinjam qualquer norma do ordenamento jurídico brasileiro;
          </p>
          <p>
            e) não transmitir e/ou divulgar qualquer material que viole direitos de terceiro, incluindo, mas sem
            limitação, direitos de propriedade intelectual de terceiros;
          </p>
          <p>f) não se fazer passar por terceiros;</p>
          <p>
            g) não utilizar tais serviços para divulgar/expor quaisquer tipos de vírus ou arquivos contendo quaisquer
            tipos de vírus (tais como, Cavalos de Tróia, malware, etc.);
          </p>
          <p>
            h) cumprir todas as leis aplicáveis com relação à transmissão de dados a partir do Brasil ou do território
            onde o USUÁRIO resida;
          </p>
          <p>
            i) não obter ou tentar obter acesso não autorizado a outros sistemas ou redes de computadores conectados ao
            serviço;
          </p>
          <p>
            j) ser o único responsável pelo conteúdo e informações que vier a disponibilizar nos serviços da GROUP
            SOFTWARE;
          </p>
          <p>k) não interferir ou interromper os serviços ou os servidores ou redes conectadas ao serviço;</p>
          <p>
            l) cumprir todos os requerimentos, procedimentos, políticas, e regulamentos de redes conectadas ao serviço;
            e
          </p>
          <p>
            m) providenciar todo o equipamento necessário para efetuar sua conexão à Internet, incluindo, mas não se
            limitando a energia elétrica, linha telefônica, smartphone e conexão com a rede.
          </p>
          <p>
            II.3. É dever do USUÁRIO checar sobre a exatidão das informações e dados de seu documento fiscal eletrônico,
            ficando responsável por fiscalizar e reparar/corrigir eventuais contradições referentes ao conteúdo e ao
            documento fiscal eletrônico em si.
          </p>
          <p>
            II.4. A veracidade, idoneidade e precisão das informações contidas no sistema são de responsabilidade única
            e exclusiva do USUÁRIO.
          </p>
          <p>
            II.5. É de responsabilidade exclusiva do USUÁRIO o conhecimento das imposições tributárias e contábeis, leis
            vigentes e determinações da Receita Federal, Estadual e/ou Municipal, concernentes aos dados e informações
            necessários para a emissão dos documentos fiscais eletrônicos que seu ramo de atividade exige.
          </p>
          <p>
            II.6. O USUÁRIO concorda em não tomar qualquer medida que possa comprometer a segurança do GROUP PAY,
            torná-lo inacessível para si e para outros, causar danos ao seu CONTEÚDO, bem como possa macular a imagem da
            GROUP SOFTWARE perante terceiros.
          </p>
          <p>
            II.7. A utilização do GROUP PAY poderá ser cancelada a qualquer tempo e independente de notificação prévia:
            (a) caso a GROUP SOFTWARE tome o conhecimento, por si ou por terceiros que o USUÁRIO violou qualquer
            disposição deste Termo de Uso, por qualquer modo; ou (b) caso o vínculo jurídico-comercial mantido entre a
            GROUP SOFTWARE e o USUÁRIO venha a ser terminado, seja por que motivo for.
          </p>
          <p>
            II.8. O USUÁRIO deve manter suas senhas em sigilo. As senhas são de uso pessoal e intransferível e a GROUP
            SOFTWARE não se responsabiliza pelo seu mau uso, permanecendo o respectivo titular da senha exclusivamente
            responsável pelo eventual dano e/ou prejuízo decorrente da utilização indevida e/ou desautorizada.{" "}
          </p>
          <p>
            II.9. O USUÁRIO assume integral e exclusiva responsabilidade perante a GROUP SOFTWARE e a terceiros
            decorrente de:
          </p>
          <p>i. violação das cláusulas deste Termos e Condições Gerais de Uso;</p>
          <p>ii. falsificação ou inexatidão de informações solicitadas;</p>
          <p>iii. uso dos serviços para a prática de atos ilegais, abusivos ou não moralmente aceitos.</p>
          <h4>III. DAS OBRIGAÇÕES E RESPONSABILIDADES DA GROUP SOFTWARE</h4>
          <p>
            III.1. A GROUP SOFTWARE é comprometida com elevados padrões de excelência e aplica seus melhores esforços
            para que o USUÁRIO desfrute de máxima qualidade e segurança nas operações realizadas pelo GROUP PAY.
            Contudo, devido às características inerentes ao ambiente online e ao estado da arte em matéria de segurança,
            interação com o sistema e conexão com a rede, as garantias fornecidas pela GROUP SOFTWARE são limitadas,
            conforme as disposições a seguir:
          </p>
          <p>
            a) Pressuposto deste Termo de Uso: as limitações aqui estabelecidas são partes essenciais deste Termo e, na
            ausência destas disposições, os presentes termos e condições gerais de uso seriam substancialmente
            diferentes. A avaliação dos riscos e a viabilidade econômica desta transação, executada pela GROUP SOFTWARE
            para o lançamento de seus produtos no mercado, determinação de preços etc., leva em consideração as
            limitações de responsabilidade aqui estabelecidas.
          </p>
          <p>
            b) Estado da Técnica: o estado da técnica não permite a elaboração de programas de computador totalmente
            isentos de vícios, defeitos e/ou imunes a ataques cibernéticos ou atividades de hackers. Assim sendo, a
            GROUP SOFTWARE não garante que o GROUP PAY operará ininterruptamente em sua capacidade plena anunciada e/ou
            estará totalmente livre de erros e/ou a salvo de perdas, ataques cibernéticos, vírus, atividades de hackers
            e/ou qualquer outra intrusão de segurança. Contudo, havendo problemas críticos que impeçam o bom desempenho
            do GROUP PAY, a GROUP SOFTWARE se compromete a utilizar de seus melhores esforços para sanar o quanto antes
            tais problemas, bem como, aplicará as melhores técnicas e políticas de segurança disponíveis no mercado.
            Para tanto, a GROUP SOFTWARE:
          </p>
          <p>i. Poderá suspender uma ou mais funcionalidades do GROUP PAY; e</p>
          <p>
            ii. Não será responsabilizada por quaisquer danos, diretos e/ou indiretos, lucros cessantes, punitivos e/ou
            consequenciais que porventura venham a ser sofridos pelo USUÁRIO e/ou terceiros devido às ocorrências
            relacionadas ao estado da técnica conforme definido nesta Cláusula.
          </p>
          <p>
            c) Particularidades: o GROUP PAY não foi desenvolvido especificamente para o USUÁRIO, nem tampouco para
            atender quaisquer das suas respectivas necessidades específicas. Isto posto, a GROUP SOFTWARE não garante
            que o GROUP PAY irá atender integralmente todas as necessidades e particularidades do USUÁRIO. Dessa forma,
            a adesão a estes Termos e Condições Gerais de Uso não implica em qualquer dever, por parte da GROUP
            SOFTWARE, em realizar qualquer customização, adaptação, atualização, integração de sistemas e/ou qualquer
            outra forma de serviço que não aquelas expressamente pactuadas nestes Termos de Uso.
          </p>
          <p>
            d) Equipamentos, Serviços ou Softwares da GROUP SOFTWARE: a GROUP SOFTWARE, seus diretores, administradores,
            empregados, afiliadas, coligadas, prepostos, contratados, contratantes e/ou licenciantes não serão
            responsáveis por quaisquer danos indiretos, punitivos, especiais, consequenciais e/ou lucros cessantes
            decorrentes, direta e/ou indiretamente, do uso do GROUP PAY, dos serviços e/ou dos equipamentos fornecidos
            pela GROUP SOFTWARE, mesmo que a GROUP SOFTWARE tenha sido avisada sobre tal possibilidade.
          </p>
          <p>
            e) Equipamentos, Serviços ou Software de Terceiros: a GROUP SOFTWARE seus diretores, administradores,
            empregados, afiliadas, coligadas, prepostos, contratados, contratantes e/ou licenciantes não se
            responsabilizam por quaisquer danos diretos, indiretos, especiais, punitivos, consequenciais e/ou lucros
            cessantes sofridos pelo USUÁRIO e/ou por terceiros em decorrência, de defeitos e/ou mau funcionamento de
            equipamentos e/ou softwares de terceiros. Portanto, a GROUP SOFTWARE não será responsável, inclusive, pela
            eventual incompatibilidade do GROUP PAY com o sistema operacional ou com o hardware do dispositivo que o
            USUÁRIO venha a utilizar para executar o aplicativo.
          </p>
          <p>
            f) Casos Fortuitos/Força Maior: não haverá quaisquer responsabilidades da GROUP SOFTWARE decorrentes de
            eventos de força maior e/ou casos fortuitos, tais como, interrupção total e/ou parcial do fornecimento de
            energia e/ou acesso à internet, guerras, revoltas, protestos públicos, desabamentos de edifícios,
            tempestades, ataques cibernéticos, sabotagem, decisões judiciais especificamente impeditivas, leis e/ou
            regulamentos expressamente proibitivos, inter alia, que levem à má prestação de serviços e/ou mau
            funcionamento do GROUP PAY.
          </p>
          <p>
            g) Isenção de Conteúdo: a GROUP SOFTWARE não tem a obrigação de fiscalizar e/ou, de qualquer forma,
            acompanhar e/ou controlar o acesso, conteúdo e/ou os dados transmitidos e/ou armazenados pelo USUÁRIO, por
            conseguinte, a GROUP SOFTWARE não tem qualquer responsabilidade sobre quaisquer veiculações, inclusive de
            caráter ilegal, imoral e/ou antiético, porventura realizadas pelo USUÁRIO. Portanto, a GROUP SOFTWARE não é
            e não será responsável: (i) por qualquer informação inserida no sistema pelo USUÁRIO, ou distorção ou erro
            que possa vir a causar disparidade com o que é determinado em lei com relação às obrigações tributárias
            nacionais; (ii) qualquer erro de cálculo relacionado ao que deve ser recolhido no momento da emissão do
            documento fiscal eletrônico; (iii) por qualquer descumprimento tributário ou recolhimento equivocado do
            USUÁRIO.{" "}
          </p>
          <p>
            III.2. O SOFTWARE não é responsável pelo recolhimento do tributo, é somente uma ferramenta para captura
            automática de notas fiscais. Portanto, a GROUP SOFTWARE não é responsável, sob quaisquer circunstâncias, por
            eventuais perdas e danos relacionadas a emissão do documento fiscal.
          </p>
          <p>
            III.3. A GROUP SOFTWARE não é responsável e não realiza qualquer tipo de consultoria tributária ou
            contabilidade, apenas viabiliza a captura do documento fiscal.
          </p>
          <p>
            III.4. A GROUP SOFTWARE não será responsável por quaisquer interrupções de disponibilidade do SOFTWARE ou
            vazamento de informações causadas por vírus, worms, trojans ou outros componentes nocivos adquiridos pelo
            USUÁRIO. Neste ponto, o USUÁRIO está ciente de que deverá manter seus equipamentos eletrônicos livres de
            qualquer malware mencionado acima, bem como será responsável exclusivo por qualquer dano que for causado à
            GROUP SOFTWARE ou a terceiros.
          </p>
          <p>
            III.5. A atualização da ferramenta visa corrigir bugs atuais e/ou incorporar novas funções, e não contém
            qualquer programa potencialmente indesejado. Essa funcionalidade não contém vírus, trojan, worm e/ou
            programa potencialmente indesejado (PUP). Quanto aos problemas causados direta e/ou indiretamente por
            downloads em sites não especificados, como infecção por vírus, cavalos de troia e/ou ataques de hackers, a
            GROUP SOFTWARE não assume qualquer responsabilidade.
          </p>
          <p>
            III.6. A GROUP SOFTWARE adota medidas para garantir que todas as informações fornecidas pelo USUÁRIO sejam
            divulgadas apenas conforme especificado na Política de Privacidade. Esta, no entanto, não pode garantir que,
            em função do mau uso do USUÁRIO, as informações introduzidas pelo USUÁRIO não serão desviadas,
            interceptadas, excluídas, destruídas ou utilizadas por outras pessoas.
          </p>
          <p>
            III.7. Ao usar o aplicativo, o USUÁRIO concorda em não responsabilizar a GROUP SOFTWARE ou qualquer um de
            seus sócios e autorizados por qualquer perda ou dano de qualquer natureza que o USUÁRIO tenha sofrido como
            resultado de apropriação indevida, interceptação, exclusão, destruição ou uso de informações pelo USUÁRIO
            cadastradas no SOFTWARE.
          </p>
          <h4>IV. PROPRIEDADE INTELECTUAL E DIREITOS AUTORAIS </h4>
          <p>
            IV.1. O USUÁRIO não adquire, pelo presente instrumento, nenhum direito de propriedade intelectual ou de
            qualquer outra natureza sobre o SOFTWARE e seus componentes, assim não terá, em nenhuma hipótese, acesso ao
            seu código fonte.
          </p>
          <p>
            IV.2. Todo o conteúdo incluído no GROUP PAY, tais como textos, gráficos, logotipos, ícones de botão,
            imagens, clipes de áudio, downloads digitais, compilação de dados e demais itens que compõem o SOFTWARE,
            aqui definidos como CONTEÚDO, é de propriedade da GROUP SOFTWARE ou de seus respectivos fornecedores, e está
            protegido pelas leis brasileiras e internacionais aplicadas no direito brasileiro sobre direitos autorais.
          </p>
          <p>
            IV.3. O SOFTWARE, o logotipo, a marca, as insígnias, os símbolos, os manuais, a documentação técnica ou
            qualquer outro sinal distintivo e material correlato constituem direitos autorais, segredos comerciais de
            titularidade da GROUP SOFTWARE.
          </p>
          <p>
            IV.4. O USUÁRIO não tem direito de desmontar, descompilar, descriptografar, piratear, emular, explorar nem
            fazer engenharia reversa do SOFTWARE ou do CONTEÚDO incluído ou acessível por meio da ferramenta, ou, de
            qualquer outro modo, explorar o SOFTWARE. O USUÁRIO também não tem direito de remover qualquer aviso de
            direito autoral, direito de marca ou outro aviso de direito de propriedade de qualquer parte do SOFTWARE,
            tampouco utilizar a licença para servir de justificativa para coletar dados indevidamente ou invadir a
            privacidade dos usuários. A desobediência a essas disposições será considerada violação de direito e aquele
            que a praticou deverá arcar com todas as consequências cabíveis.
          </p>
          <p>
            IV.5. O uso indevido de materiais protegidos por propriedade intelectual (direito autoral, marcas
            comerciais, patentes etc.) apresentados na GROUP SOFTWARE será caracterizado como infração da legislação
            pertinente, sujeitando o infrator às ações judiciais cabíveis e dando ensejo à respectiva indenização e
            demais cominações legais.
          </p>
          <h4>V. PRIVACIDADE E PROTEÇÃO DE DADOS</h4>
          <p>
            V.1. O USUÁRIO é responsável por manter a confidencialidade de senhas utilizadas para acessar o GROUP PAY.
            Desta forma, o USUÁRIO será o único responsável perante a GROUP SOFTWARE por todas as atividades que ocorram
            na sua conta.
          </p>
          <p>
            V.2. A GROUP SOFTWARE se resguarda ao direito de disponibilizar a terceiros um espaço para publicidade no
            âmbito do aplicativo, sem que o USUÁRIO ou quaisquer terceiros tenham direito ao recebimento de qualquer
            contraprestação ou pagamento.
          </p>
          <p>
            V.3. O USUÁRIO entende e concorda que, de acordo com as definições estabelecidas na Lei Geral de Proteção de
            Dados – LGPD (Lei Federal nº 13.709/2018), possui o papel de CONTROLADOR dos dados dos titulares e a GROUP
            SOFTWARE de OPERADOR dos dados inseridos na plataforma.
          </p>
          <p>
            V.4. O tratamento de dados realizado pela GROUP SOFTWARE obedece ao disposto na Lei Geral de Proteção de
            Dados e será único e exclusivamente para identificação das partes envolvidas.
          </p>
          <h4>VI. DISPOSIÇÕES GERAIS </h4>
          <p>
            VI.1. Estes Termos e Condições Gerais de Uso serão regidos e interpretados exclusivamente de acordo com as
            leis do Brasil e atos legais internacionais aplicáveis no ordenamento jurídico nacional. Qualquer
            reclamação, conflito ou controvérsia que surgir deste contrato ou a ele relacionada, inclusive que diga
            respeito a sua validade, interpretação ou exequibilidade, será solucionada exclusivamente pelo foro de Belo
            Horizonte – MG.
          </p>
          <h4>POLÍTICA DE PRIVACIDADE</h4>
          <p>
            A Política de Privacidade aqui descrita visa a criação de uma relação salutar e duradoura entre USUÁRIO e
            GROUP SOFTWARE, de forma que a experiência proporcionada a ambos seja benéfica, eficaz e pautada pela boa-fé
            e os princípios éticos de qualidade de dados, transparência, segurança, prevenção, não discriminação,
            responsabilização e prestação de contas, livre acesso, finalidade, necessidade e adequação; preceitos estes
            previstos expressamente no artigo 6º da Lei Geral de Proteção de Dados – LGPD (Lei Federal nº 13.709/2018).
            Proteger a informação privada é a nossa prioridade. Esta política governa a coleta e uso de dados. Ao
            utilizar o SOFTWARE, o USUÁRIO concorda com as práticas descritas nesta declaração.
          </p>
          <h4>I. Coleta de Informação Pessoal</h4>
          <p>
            I.1. A GROUP SOFTWARE pode coletar informações de identificação pessoal, como nome, data de nascimento, CPF,
            endereço eletrônico, endereço de correspondência, senha, número de telefone do USUÁRIO, bem como outras
            informações pessoais ou não pessoais.{" "}
          </p>
          <p>I.2. Os dados pessoais dos USUÁRIOS serão colhidos nos seguintes momentos da relação firmada:</p>
          <p>
            i. no registro do USUÁRIO no SOFTWARE, onde aquele se submete expressamente aos Termos e Condições Gerais de
            Uso e Política de Privacidade de Dados aqui descritos;
          </p>
          <p>
            ii. em momentos futuros posteriores ao registro acima citado, mas dentro do período de prestação dos
            serviços, quando a GROUP SOFTWARE necessitar: a) de dados para melhorar a experiência do USUÁRIO; b)
            corrigir, aperfeiçoar ou modificar serviços técnicos prestados; c) ampliar, reduzir, diversificar, ramificar
            ou atividades correlatas referentes ao fornecimento de serviço; d) necessitar atualizar o sistema conforme
            seus critérios próprios; e) realizar atividades técnicas de manutenção ou atividades correlatas;
          </p>
          <p>
            I.3. Informações sobre hardware e software, além de informações de rede móvel do USUÁRIO, podem ser
            coletadas automaticamente pela GROUP SOFTWARE e todas as suas aplicações. Estas informações podem incluir:
            endereço de IP, tipo de navegador, nomes de domínio, acessos e consultas a websites, operadora de telefonia
            e número de telefone.{" "}
          </p>
          <p>
            I.4. Podemos coletar e armazenar informações localmente no dispositivo do USUÁRIO usando mecanismos como
            armazenamento no navegador web e caches de dados de aplicativos. Estas informações são usadas para garantir
            a operação e a qualidade de nossos serviços, obter estatísticas gerais de utilização e manter o cadastro
            atualizado.
          </p>
          <p>
            I.5. Podem ocorrer ainda a obtenção de dados sobre as atividades do USUÁRIO. Tais dados poderão ser
            agregados e utilizados para ajudar a entender comportamentos junto aos nossos produtos, serviços e/ou
            quaisquer outras funcionalidades ofertadas. Dados agregados são considerados informações não-pessoais para
            fins dessa Política de Privacidade.{" "}
          </p>
          <p>
            I.6. O USUÁRIO é responsável pelo sigilo de seus dados. Não devendo, portanto, compartilhar senhas e/ou
            dados de acesso com quaisquer pessoas, sendo entendida tal prática como violação a este Termo.
          </p>
          <h4>II. Uso da Informação Pessoal </h4>
          <p>
            II.1. A GROUP SOFTWARE coleta e usa informações pessoais do USUÁRIO para operar uma plataforma de serviço de
            gestão e automação de processos. Os dados coletados são usados para fornecer, manter, proteger e melhorar
            nossos serviços, desenvolver novos e proteger a GROUP SOFTWARE e seus usuários.
          </p>
          <p>
            II.2. A GROUP SOFTWARE fica autorizada a realizar as seguintes práticas com os dados fornecidos, com base
            nos ordenamentos legais vigentes e princípios aqui descritos:{" "}
          </p>
          <p>
            i. utilizar, tratar, comunicar internamente, organizar, catalogar, classificar, dividir ou separar os dados
            e informações fornecidas pelo USUÁRIO;
          </p>
          <p>ii. alimentar seu banco de dados internos com os dados fornecidos do USUÁRIO;</p>
          <p>
            iii. utilizar os dados fornecidos para fins administrativos e internos, gerando estudos e promoção de
            campanhas visando aperfeiçoar a experiência do USUÁRIO;
          </p>
          <p>
            iv. comunicar-se especificamente com o USUÁRIO com base no perfil de dados fornecidos por este e seu
            registro de histórico (LOGS);
          </p>
          <p>v. fornecer informações do USUÁRIO em cumprimento de determinações judiciais e legais;</p>
          <p>
            vi. envio de janelas (pop-ups) ao USUÁRIOS sobre funcionalidades do SOFTWARE; melhoramentos, atualização e
            modificações; ofertas e possibilidades e outras situações em que se fizer necessário esta comunicação;
          </p>
          <p>vii. avaliar a eficiência da comunicação entre SOFTWARE e USUÁRIO e publicidade.</p>
          <p>
            II.3. A GROUP SOFTWARE poderá utilizar as informações pessoais do USUÁRIO para informá-lo de outros produtos
            ou serviços disponibilizados pela GROUP SOFTWARE, suas afiliadas, parceiros ou clientes. A GROUP SOFTWARE
            também poderá contatar o USUÁRIO para conduzir pesquisas sobre sua opinião de serviços atuais ou de serviços
            novos e potenciais, que possam ser oferecidos.
          </p>
          <p>
            II.4. A GROUP SOFTWARE irá disponibilizar as informações pessoais do USUÁRIO, sem aviso prévio, somente se
            forem requisitadas por lei ou na crença de boa-fé que tal ação seja necessária para: a) cumprir qualquer
            legislação, regulamentação, processo legal ou solicitação governamental aplicável; b) cumprir Termos de
            Serviço aplicáveis, inclusive investigação de possíveis violações; c) detectar, impedir ou abordar de alguma
            outra forma fraude, questões técnicas ou de segurança; ou d) proteger contra danos aos direitos, a
            propriedade ou a segurança da GROUP SOFTWARE, nossos usuários ou o público, conforme solicitado ou permitido
            por lei.
          </p>
          <h4>III. Compartilhamento de Dados </h4>
          <p>
            III.1. Não há que se falar em comercialização dos dados a terceiros, porém existem situações nas quais
            ocorre a divulgação, transferência e/ou compartilhamento dos dados com terceiros, conforme disposto nessa
            Política de Privacidade e nas legislações vigentes e aplicáveis.
          </p>
          <p>
            III.2. Poderá ocorrer a venda ou a compra de outras empresas ou ativos. Em caso de venda, fusão,
            reorganização, dissolução da empresa ou outra operação societária semelhante, os dados poderão fazer parte
            dos ativos intangíveis compartilhados ou transferidos.
          </p>
          <p>
            III.3. Poderá ocorrer o compartilhamento de dados com empresas do mesmo grupo econômico, com as seguintes
            finalidades:
          </p>
          <p>i. Desenvolvimento de novos produtos e/ou serviços;</p>
          <p>ii. A oferta de produtos e/ou serviços que melhor atendam aos seus interesses; e</p>
          <p>iii. A geração de dados estatísticos e agregados acerca do uso de produtos e/ou serviços e perfis.</p>
          <p>
            III.4. Poderá ocorrer o compartilhamento dos dados com contratados e prestadores de serviços que tratam tais
            dados, de modo a desempenhar determinadas funções relacionadas aos nossos produtos, serviços e/ou quaisquer
            outras funcionalidades, tais como, mas não somente, agências de marketing, prestadores de serviços de bancos
            de dados, prestadores de serviços de recuperação após desastres e de cópias de segurança, prestadores de
            serviços de e-mail, processadores de pagamentos e outros.
          </p>
          <p>
            III.5. Poderá ocorrer o compartilhamento dos dados com autoridades policiais ou judiciais, autoridades
            públicas competentes ou outros terceiros, dentro e fora do Brasil, caso seja requerido pela legislação
            aplicável, por decisão judicial e por requisição de autoridades, ou se necessário para responder a processos
            judiciais ou para participar em eventuais litígios ou disputas de qualquer natureza.
          </p>
          <p>
            III.6. Nestas situações, será necessário cooperar com as autoridades competentes na medida em que,
            discricionariamente, entenda necessário e adequado em relação a qualquer investigação de ilícitos, infrações
            a direitos de propriedade industrial ou intelectual, ou outra atividade que seja ilegal ou que possa expor
            as operações a qualquer responsabilidade legal ou lhes impor riscos, ressalvadas hipóteses de sigilo de
            informações constantes nas legislações vigentes e aplicáveis.
          </p>
          <p>
            III.7. Poderá ocorrer o compartilhamento dos dados com terceiros quando houver motivos suficientes para
            considerar que a atividade é suspeita, ilegal ou prejudicial à operação ou a terceiros.
          </p>
          <h4>IV. Armazenamento de Dados </h4>
          <p>
            IV.1. Os dados coletados serão armazenados em serviços de nuvens confiáveis, providos por parceiros que
            podem estar localizados no Brasil ou em outros países, tais como Estados Unidos da América – EUA e em países
            da União Europeia – UE.
          </p>
          <p>
            IV.2. Na contratação desses serviços, são contratadas empresas que empregam alto nível de segurança no
            armazenamento de seus dados, estabelecendo contratos que não violam as definições de privacidade previstas
            nessa Política de Privacidade.
          </p>
          <p>
            IV.3. Os dados são armazenados tão somente pelo período necessário para as finalidades aplicáveis,
            respeitando o período de retenção de dados determinado pelas legislações vigentes e aplicáveis.
          </p>
          <p>
            IV.4. Se o USUÁRIO solicitar a exclusão dos seus dados os mesmos serão anonimizados ou excluídos
            definitivamente, salvo se tais dados forem necessários para cumprimento de obrigação legal, atendimento de
            legítimo interesse ou para exercício regular de direitos em processo judicial, administrativo e/ou arbitral.
          </p>
          <p>
            IV.5. São empregados os melhores esforços para respeitar e proteger os dados contra perdas, roubos e/ou
            quaisquer modalidades de uso indevido, bem como contra acessos não autorizados, divulgações, alterações e/ou
            destruições.
          </p>
          <p>
            IV.6. O tratamento de dados será realizado mediante alto grau de segurança, com a implementação das melhores
            práticas em uso na indústria para a proteção de dados, tais como técnicas de criptografia, monitoração e
            testes de segurança periódicos, firewall, entre outros. No entanto, não é possível garantir completamente a
            não ocorrência de interceptações e violações dos sistemas e bases de dados, uma vez que a Internet possui
            sua estrutura de segurança em permanente aperfeiçoamento.
          </p>
          <p>
            IV.7. Em caso de incidente de segurança da informação que resulte na destruição, perda, alteração, acesso
            não-autorizado, ou vazamento de dados, ocorrerá uma avaliação imediata quanto aos riscos às liberdades civis
            e aos direitos fundamentais dos titulares dos dados. A comunicação aos titulares ou à Autoridade Nacional de
            Proteção de Dados será realizada conforme o caso concreto, após avaliação dos riscos mencionados.
          </p>
          <h4>V. Transferência Internacional de Dados</h4>
          <p>
            V.1. Poderá ocorrer a realização de transferências internacionais de dados para outros países, tais como
            Estados Unidos da América e para países da União Europeia, a fim de proporcionar total disponibilidade de
            nossos produtos, serviços e/ou quaisquer outras funcionalidades, bem como para poder obter informações que
            possam contribuir para o aperfeiçoamento e segurança dos mesmos.
          </p>
          <p>
            V.2. Na hipótese de compartilhamento com parceiros localizados em outros países, estabelecemos
            contratualmente que o parceiro possua padrão de proteção de dados e segurança da informação compatível com
            essa Política de Privacidade, a fim de que os dados sejam sempre protegidos nestes termos.
          </p>
          <h4>VI. Uso de Cookies </h4>
          <p>
            VI.1. O aplicativo pode usar “cookies” para ajudar a personalizar a experiência do USUÁRIO on-line. Um
            cookie é um arquivo de texto que é colocado no disco rígido por um servidor de páginas web. Os cookies não
            podem ser usados para executar programas ou enviar vírus para o computador. Os cookies são atribuídos
            exclusivamente ao USUÁRIO, e só podem ser lidos por um servidor Web no domínio que emitiu o cookie para o
            mesmo.{" "}
          </p>
          <p>
            VI.2. O USUÁRIO tem a capacidade de aceitar ou recusar cookies. A maioria dos navegadores da Web aceita
            automaticamente os cookies, mas o USUÁRIO pode modificar a configuração para recusar cookies, se preferir no
            seu navegador. Se o USUÁRIO escolher recusar os cookies, ele pode não ser capaz de experimentar os recursos
            interativos dos serviços do GROUP PAY ou sites que ele visita.
          </p>
          <h4>VII. Segurança das Informações Pessoais </h4>
          <p>
            VII.1. A GROUP SOFTWARE se compromete a trabalhar com afinco para proteger seus usuários de acesso não
            autorizado ou alteração, divulgação ou destruição não autorizada das informações que detém.
          </p>
          <h4>VIII. Opt-Out e Cancelamento</h4>
          <p>
            VIII.1. Nós respeitamos a privacidade do USUÁRIO e oferecemos a oportunidade de optar por não receber
            anúncios de determinadas informações. O USUÁRIO pode optar por não receber qualquer ou todas as comunicações
            da GROUP SOFTWARE, contatando-nos em dpo@groupsoftware.com.br.{" "}
          </p>
          <h4>IX. Canal de Comunicação</h4>
          <p>
            IX.1. O canal de comunicação com o USUÁRIO será o e-mail fornecido por este em seu credenciamento, sendo que
            qualquer solicitação relativa aos seus dados deverá ser comunicada pelo seguinte e-mail:
            dpo@groupsoftware.com.br.{" "}
          </p>
          <p>
            IX.2. Por meio deste canal mencionado, o USUÁRIO poderá alterar suas concessões de consentimento para
            tratamento de seus dados, conceder novas permissões ou retirar seu consentimento para as permissões atuais,
            sendo avisado das consequências que a retirada de consentimento poderá causar.
          </p>
          <h4>X. Alterações desta Política de Privacidade</h4>
          <p>
            As disposições constantes na Política de Privacidade poderão ser atualizadas ou modificadas a qualquer
            momento, cabendo ao USUÁRIO verificá-la sempre que efetuarem o acesso ao GROUP PAY.
          </p>
          <p>
            Caso haja mudança substancial na maneira de usar as informações pessoais coletadas, as novas condições de
            privacidade e segurança da informação serão informadas previamente ao USUÁRIO por meio do SOFTWARE.
          </p>
          <p>
            Caso alguma disposição desta Política de Privacidade seja considerada ilegal ou ilegítima por autoridade da
            localidade em que resida ou da sua conexão à Internet, as demais condições permanecerão em pleno vigor e
            efeito.
          </p>
          <p>
            O USUÁRIO deverá entrar em contato em caso de qualquer dúvida com relação às disposições constantes deste
            Termo e Condições Gerais de Uso ou da Política de Privacidade através dos meios de comunicação
            disponibilizados.
          </p>
          <p>
            Ao aceitar estes Termos e Condições Gerais de Uso e Política de Privacidade, o USUÁRIO fornece consentimento
            válido, livre e inequívoco para a realização de tratamento dos dados conforme mencionado acima, considerado
            para todos os efeitos o mesmo exigido em dispositivos legais quanto a proteção de dados.
          </p>
          <p>
            Em caso de retirada ou revogação do consentimento por parte do USUÁRIO, os serviços e funcionalidades
            poderão ficar indisponíveis. 
          </p>
          <h4>XI. Disposições Gerais e Eleição de Foro </h4>
          <p>
            O USUÁRIO aceita todo o disposto nessa Política de Privacidade e demais políticas legais que se encontram
            vigentes na data de acesso. Por isso, é recomendável que o USUÁRIO se mantenha atualizado.
          </p>
          <p>
            Eventual tolerância quanto a qualquer violação dos termos e condições do contido nessa Política de
            Privacidade será considerada mera liberalidade e não será interpretada como novação, precedente invocável,
            renúncia a direitos, alteração tácita dos termos contratuais, direito adquirido ou alteração contratual.
          </p>
          <p>
            Sempre que possível, potenciais divergências serão resolvidas de forma amigável. Quando todos os esforços
            neste sentido forem esgotados, o USUÁRIO concorda, desde já, que fica eleito o foro da comarca de Belo
            Horizonte, no Estado de Minas Gerais, para resolver controvérsias ou queixas oriundas dos nossos produtos,
            serviços e/ou quaisquer outras funcionalidades ou relacionadas a essa Política de Privacidade.
          </p>
        </div>
      </div>
    );
  };

  return (
    <CustomModal
      key={"modal-visualizar-termos-de-uso"}
      titulo="Termos de Uso - Group Pay"
      size="xl"
      tipoModal="MODAL_LATERAL"
      fecharModalAoClicarFora
      scrollable
      onCloseModal={props.onCloseModal}
      showModal={props.showModal}
    >
      <div className="d-flex flex-column">
        {renderTitulo()}
        {renderConteudo()}
      </div>
    </CustomModal>
  );
};

export default ModalTermosDeUsoGroupPay;
